import { getType } from 'typesafe-actions';
import { SyncInfoActions, syncInfoActions } from '../creators/syncInfo';
import { SyncInfo } from 'modules/app/types';

export type SyncInfoState = SyncInfo | null;

const syncInfoReducer = (state: SyncInfo | null = null, action: SyncInfoActions) => {
  switch (action.type) {
    case getType(syncInfoActions.getSyncInfoRequest.success):
      return action.payload;

    default:
      return state;
  }
};

export default syncInfoReducer;
